import { adminClient, type AdminSession } from "../api/admin-client";

export type { AdminSession };

export function fetchAdminSession(signal?: AbortSignal): Promise<AdminSession> {
  return adminClient.getSession(signal);
}

export function reauthenticateAdmin(password: string, totpCode?: string | null) {
  return adminClient.reauthenticate({ password, totp_code: totpCode ?? null });
}
